(function () {
  'use strict';

  angular
    .module('minRestBreachPriorToRktDeparture')
    .service('minRestBreachPriorToRktDepartureService', minRestBreachPriorToRktDepartureService);

  function minRestBreachPriorToRktDepartureService(CommonMasterData,RemoteService) {
    var vm = this;

    vm.searchMinRestBreachPriorToRktDeparture= function (param ,successFn,errorFn) {
      var searchParam = adaptSearchRequset(param);
      RemoteService.searchMinRestBreachPriorToRktDeparture(searchParam).then(
        function (response) {
          successFn(response);
        },
        function (error) {
          errorFn(error.msg);
        }
      );
    };

    function adaptSearchRequset(param) {
      var actualSearchParam = {
        fromDate : param.fromDate,
        toDate: param.toDate,
        crewType:(param.crewType !=null ) ? param.crewType.crewTypeCode:null,
        autoOrManual: (param.autoOrManual != null) ? param.autoOrManual.autoOrManualCode:null
      };

      return actualSearchParam;
    }

  }
}());
